import React from 'react';
import cn from 'classnames';
import SVGWrapper from '@repo/icons/SVGWrapper';
import { SVGProps } from '@repo/utils/types';
import styles from './EllipsisToXIcon.module.scss';

export function EllipsisToXIcon({
  isOpen,
  toggleClassName,
  triggerProps,
  hoverOpacity = true,
  containerWidth = 16,
  containerHeight = 15,
  ...svgProps
}: SVGProps & {
  isOpen: boolean;
  toggleClassName?: string;
  triggerProps?: Record<string, any>;
  containerWidth?: number;
  containerHeight?: number;
}) {
  return (
    <div
      className={cn(styles.toggleIcon, toggleClassName, isOpen && styles.open, isOpen && 'open')}
      style={{ width: containerWidth, height: containerHeight }}
    >
      <SVGWrapper
        viewBox="-1 -1 16 16"
        color="primary"
        {...svgProps}
        hoverOpacity={isOpen ? false : hoverOpacity}
      >
        <circle stroke="none" cx="1.6" cy="7" r="1.9" />
        <circle stroke="none" cx="7" cy="7" r="1.9" />
        <circle stroke="none" cx="12.4" cy="7" r="1.9" />
        <g
          strokeLinecap="round"
          strokeWidth="1.9"
          strokeDasharray="7.5 7.5"
          strokeDashoffset="7.45"
          transform="translate(0.25, 0)"
        >
          <path d="M7 7l5.3 5.3" />
          <path d="M7 7l5.3 -5.3" />
          <path d="M7 7l-5.3 -5.3" />
          <path d="M7 7l-5.3 5.3" />
        </g>
      </SVGWrapper>
    </div>
  );
}
